import { AssetSetType } from '@droidmap/shared-service-contract'

import type { Accent } from './accent'

/** Long-form labels (used in tables, modal filters, dropdowns). */
export const ASSET_SET_TYPE_LABEL: Record<AssetSetType, string> = {
  [AssetSetType.DroneImages]: 'Drone Images',
  [AssetSetType.OdmOutputs]: 'ODM Outputs',
  [AssetSetType.Lidar]: 'LiDAR',
  [AssetSetType.MapLayers]: 'Map Layers',
  [AssetSetType.GCPOutputs]: 'GCP Outputs',
  [AssetSetType.Other]: 'Other',
}

/** Compact labels (used in dashboard summary badges and tight rows). */
export const ASSET_SET_TYPE_LABEL_SHORT: Record<AssetSetType, string> = {
  [AssetSetType.DroneImages]: 'Drone',
  [AssetSetType.OdmOutputs]: 'ODM',
  [AssetSetType.Lidar]: 'LiDAR',
  [AssetSetType.MapLayers]: 'Map',
  [AssetSetType.GCPOutputs]: 'GCP',
  [AssetSetType.Other]: 'Other',
}

export const ASSET_SET_TYPE_TONE: Record<AssetSetType, Accent> = {
  [AssetSetType.DroneImages]: 'violet',
  [AssetSetType.OdmOutputs]: 'cyan',
  [AssetSetType.Lidar]: 'teal',
  [AssetSetType.MapLayers]: 'success',
  [AssetSetType.GCPOutputs]: 'warning',
  [AssetSetType.Other]: 'neutral',
}
